import { ENDPOINTS } from 'src/constants/endpoints'

import DateAdapter from 'src/app/core/adapters/date/DateAdapter'

import type { IDocumentItemDTO } from '../contracts/documents'

export interface IDocumentOverviewEntity {
  id: string
  documentTitle: string
  category: string
  addedAt: string
  releaseDate: string
  displayDate: string
  documentUrl: string
}

const removePdfExtension = (fileName: string): string =>
  fileName.replace(/\.pdf$/i, '')

const resolveDownloadUrl = (dto: IDocumentItemDTO): string => {
  if (dto.section.includes('insights')) {
    return ENDPOINTS.hanwha.memberInsightDownload(dto.id)
  }
  return ENDPOINTS.hanwha.fundUpdateDownload(dto.id)
}

export const mapDocumentItem = (
  dto: IDocumentItemDTO,
): IDocumentOverviewEntity => ({
  id: dto.id,
  documentTitle: removePdfExtension(dto.file_name),
  category: dto.category,
  addedAt: dto.added_at ?? dto.release_date,
  releaseDate: dto.release_date,
  displayDate: DateAdapter.formatReleaseDate(dto.release_date),
  documentUrl: resolveDownloadUrl(dto),
})
